<div class="exception-body">
    <div class="exception-topbar">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');" class="logo">
            <img [src]="this.logo_url" alt="eglobaldoctors" />
        </a>
    </div>
    <div class="container top-bottom-space">
        <div class="ui-lg-6">
            <div class="exception-panel" style="padding-top: 10%;">
                <h1 class="exception-summary">Invalid Link </h1>
                <div class="exception-detail">
                    <h4>You will be redirected to the home page in</h4>
                    <h4>
                        <countdown [config]="seconds"></countdown>
                    </h4>
                </div>

                <div>
                    <button type="button" pButton label="Go To Home" [routerLink]="['/', this.slug]"></button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-home-footer></app-home-footer>